import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import TokenBalance from '../Components/tokenBalance';
import { QRCodeSVG } from "qrcode.react";
import axios from 'axios';
import Web3 from 'web3';
import './MasterWallet.css';

// Binance Smart Chain configuration
const BSC_RPC_URLS = [
  'https://bsc-dataseed1.binance.org/'
];

// BEP20 Token ABI (minimal for balance checking)
const BEP20_ABI = [
  {
    "constant": true,
    "inputs": [{ "name": "_owner", "type": "address" }],
    "name": "balanceOf",
    "outputs": [{ "name": "balance", "type": "uint256" }],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "decimals",
    "outputs": [{ "name": "", "type": "uint8" }],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "name",
    "outputs": [{ "name": "", "type": "string" }],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "symbol",
    "outputs": [{ "name": "", "type": "string" }],
    "type": "function"
  }
];

// Token Addresses
const TOKEN_ADDRESSES = {
  USDT: '0x55d398326f99059fF775485246999027B3197955',
  BUSD: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
};

function MasterWallet() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [walletAddress, setWalletAddrees] = useState("");
  const [network, setNetwork] = useState([]);
  const [bnbBalance, setBnbBalance] = useState("0.00");
  const [usdtBalance, setUsdtBalance] = useState("0.00");
  const [busdBalance, setBusdBalance] = useState("0.00");
  const [usdcBalance, setUsdcBalance] = useState("0.00");
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [error, setError] = useState("");
  const [web3, setWeb3] = useState(null);
  const [rpcIndex, setRpcIndex] = useState(0);

  // Modal states
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [newWalletAddress, setNewWalletAddress] = useState("");
  const [walletPrivateKey, setWalletPrivateKey] = useState("");



  // Initialize Web3 connection
  useEffect(() => {
    initializeWeb3();
    fetchTicket(1);
  }, []);

  // Retry Web3 connection if failed
  useEffect(() => {
    if (!web3 && rpcIndex < BSC_RPC_URLS.length - 1) {
      const timer = setTimeout(() => {
        initializeWeb3();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [rpcIndex, web3]);

  useEffect(() => {
    if (walletAddress && web3) {
      fetchBalancesWithWeb3();
    }
  }, [walletAddress, web3]);

  // Initialize Web3 with fallback RPC endpoints
  const initializeWeb3 = async () => {
    try {
      const web3Instance = new Web3(BSC_RPC_URLS[rpcIndex]);

      // Test connection
      await web3Instance.eth.getBlockNumber();
      setWeb3(web3Instance);
      console.log(`Connected to BSC via: ${BSC_RPC_URLS[rpcIndex]}`);
    } catch (error) {
      console.error(`Failed to connect to ${BSC_RPC_URLS[rpcIndex]}:`, error);

      // Try next RPC endpoint
      if (rpcIndex < BSC_RPC_URLS.length - 1) {
        setRpcIndex(rpcIndex + 1);
      } else {
        setError('Unable to connect to Binance Smart Chain');
        toast.error('Failed to connect to BSC network');
      }
    }
  };


  const fetchTicket = async (page) => {
    console.log('Token ', authToken);

    const searchData = {
      network: 'BEP20'
    };

    try {
      const response = await axios.get(`${baseurl}/withdraw-wallet`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        params: searchData, // Use params for GET request instead of body
      });

      if (response.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const walletData = response.data;
      console.log('Static data', walletData);

      if (walletData.status) {
        setWalletAddrees(walletData.data.withdraw_address);

        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
        setDeposits("");
      }
    } catch (error) {
      if (error.response && error.response.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
      } else {
        console.error('Axios error:', error);
      }
    }
  };

  // Fetch BNB Balance using Web3
  const fetchBNBBalance = async (address) => {
    try {
      const balance = await web3.eth.getBalance(address);
      const bnbBalance = web3.utils.fromWei(balance, 'ether');
      return parseFloat(bnbBalance).toFixed(6);
    } catch (error) {
      console.error('Error fetching BNB balance:', error);
      return "0.00";
    }
  };

  // Fetch BEP20 Token Balance using Web3
  const fetchTokenBalance = async (tokenAddress, walletAddress, decimals = 18) => {
    try {
      console.log(`Fetching balance for token: ${tokenAddress}, wallet: ${walletAddress}, decimals: ${decimals}`);

      const contract = new web3.eth.Contract(BEP20_ABI, tokenAddress);
      const balance = await contract.methods.balanceOf(walletAddress).call();

      console.log(`Raw balance for ${tokenAddress}:`, balance);

      // Convert balance properly using decimals
      const adjustedBalance = parseFloat(balance.toString()) / Math.pow(10, decimals);
      console.log(`Adjusted balance for ${tokenAddress}:`, adjustedBalance);

      return adjustedBalance.toFixed(6);
    } catch (error) {
      console.error(`Error fetching token balance for ${tokenAddress}:`, error);
      return "0.00";
    }
  };

  // Get token decimals
  const getTokenDecimals = async (tokenAddress) => {
    try {
      console.log(`Fetching decimals for token: ${tokenAddress}`);
      const contract = new web3.eth.Contract(BEP20_ABI, tokenAddress);
      const decimals = await contract.methods.decimals().call();
      console.log(`Decimals for ${tokenAddress}:`, decimals);
      return parseInt(decimals);
    } catch (error) {
      console.error('Error fetching token decimals:', error);
      // Return known decimals for major BSC tokens
      if (tokenAddress.toLowerCase() === TOKEN_ADDRESSES.USDT.toLowerCase()) return 18; // USDT on BSC is 18 decimals
      if (tokenAddress.toLowerCase() === TOKEN_ADDRESSES.BUSD.toLowerCase()) return 18; // BUSD is 18 decimals
      if (tokenAddress.toLowerCase() === TOKEN_ADDRESSES.USDC.toLowerCase()) return 18; // USDC on BSC is 18 decimals
      return 18; // Default to 18 decimals
    }
  };

  // Main function to fetch all balances using Web3
  const fetchBalancesWithWeb3 = async () => {
    if (!walletAddress || !web3) {
      console.log('Wallet address or Web3 not available');
      return;
    }

    setBalanceLoading(true);
    setError("");

    try {
      console.log('=== Starting balance fetch ===');
      console.log('Wallet Address:', walletAddress);
      console.log('Web3 Instance:', web3 ? 'Available' : 'Not Available');

      // Test Web3 connection first
      try {
        const blockNumber = await web3.eth.getBlockNumber();
        console.log('Current block number:', blockNumber);
      } catch (blockError) {
        console.error('Web3 connection test failed:', blockError);
        throw new Error('Web3 connection failed');
      }

      // Fetch BNB Balance (native token)
      console.log('--- Fetching BNB Balance ---');
      const bnbBal = await fetchBNBBalance(walletAddress);
      setBnbBalance(bnbBal);
      console.log('✅ BNB Balance set:', bnbBal);

      // Fetch USDT Balance (BEP20 token)
      console.log('--- Fetching USDT Balance ---');
      try {
        const usdtDecimals = await getTokenDecimals(TOKEN_ADDRESSES.USDT);
        const usdtBal = await fetchTokenBalance(TOKEN_ADDRESSES.USDT, walletAddress, usdtDecimals);
        setUsdtBalance(usdtBal);
        console.log('✅ USDT Balance set:', usdtBal);
      } catch (usdtError) {
        console.error('❌ USDT Balance failed:', usdtError);
        setUsdtBalance("0.00");
      }

      // Fetch BUSD Balance (BEP20 token)
      console.log('--- Fetching BUSD Balance ---');
      try {
        const busdDecimals = await getTokenDecimals(TOKEN_ADDRESSES.BUSD);
        const busdBal = await fetchTokenBalance(TOKEN_ADDRESSES.BUSD, walletAddress, busdDecimals);
        setBusdBalance(busdBal);
        console.log('✅ BUSD Balance set:', busdBal);
      } catch (busdError) {
        console.error('❌ BUSD Balance failed:', busdError);
        setBusdBalance("0.00");
      }

      // Fetch USDC Balance (BEP20 token)
      console.log('--- Fetching USDC Balance ---');
      try {
        const usdcDecimals = await getTokenDecimals(TOKEN_ADDRESSES.USDC);
        const usdcBal = await fetchTokenBalance(TOKEN_ADDRESSES.USDC, walletAddress, usdcDecimals);
        setUsdcBalance(usdcBal);
        console.log('✅ USDC Balance set:', usdcBal);
      } catch (usdcError) {
        console.error('❌ USDC Balance failed:', usdcError);
        setUsdcBalance("0.00");
      }

      console.log('=== Balance fetch completed ===');

    } catch (error) {
      console.error('💥 Fatal error fetching balances with Web3:', error);
      setError('Failed to fetch balances: ' + error.message);
      toast.error('Failed to fetch balances from blockchain: ' + error.message);
    } finally {
      setBalanceLoading(false);
    }
  };

  // Legacy function for backward compatibility (now calls Web3 version)
  const fetchBalances = () => {
    fetchBalancesWithWeb3();
  };



  const copyToClipboard = () => {
    if (walletAddress) {
      navigator.clipboard.writeText(walletAddress)
        .then(() => {
          toast.success("Wallet address copied to clipboard!");
        })
        .catch((error) => {
          console.error("Failed to copy:", error);
        });
    }
  };


  const getSoon = () => {
    toast.warning('Comming soon !')
  }

  // Update wallet address function
  const updateWalletAddress = async () => {
    if (!newWalletAddress.trim()) {
      toast.error('Please enter a wallet address');
      return;
    }

    if (!walletPrivateKey.trim()) {
      toast.error('Please enter wallet private key');
      return;
    }

    // Basic validation for wallet address format
    if (!newWalletAddress.startsWith('0x') || newWalletAddress.length !== 42) {
      toast.error('Please enter a valid wallet address');
      return;
    }

    setUpdateLoading(true);

    try {
      const updateData = {
        withdrawAddress: newWalletAddress,
        withdrawKey: walletPrivateKey,
      };

      const response = await axios.post(`${baseurl}/update-withdraw-wallet`, updateData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        }
      });

      if (response.data.status) {
        toast.success('Wallet updated successfully!');
        setWalletAddrees(newWalletAddress);
        setShowUpdateModal(false);
        setNewWalletAddress("");
        setWalletPrivateKey("");

        // Refresh balances with new wallet
        if (web3) {
          setTimeout(() => {
            fetchBalancesWithWeb3();
          }, 1000);
        }
      } else {
        toast.error(response.data.message || 'Failed to update wallet');
      }
    } catch (error) {
      console.error('Error updating wallet:', error);
      toast.error('Failed to update wallet: ' + (error.response?.data?.message || error.message));
    } finally {
      setUpdateLoading(false);
    }
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowUpdateModal(false);
    setNewWalletAddress("");
    setWalletPrivateKey("");
  };



  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0 fw-bold text-primary">
                  <i className="fas fa-wallet me-2"></i>Master Wallet Dashboard
                </h4>
                <p className="text-muted mb-0">Manage your BEP20 wallet and view balances</p>
              </div>
              <div>
                <button
                  onClick={() => setShowUpdateModal(true)}
                  className="btn btn-success btn-sm me-2"
                >
                  <i className="fas fa-edit me-1"></i>
                  Update Wallet
                </button>
                <button
                  onClick={fetchBalances}
                  className="btn btn-primary btn-sm refresh-btn"
                  disabled={balanceLoading}
                >
                  <i className="fas fa-sync-alt me-1"></i>
                  {balanceLoading ? 'Refreshing...' : 'Refresh Balances'}
                </button>
              </div>
            </div>
            {/* End Page Header */}

            {/* Balance Cards Row */}
            <div className="row mb-4">
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div className="card custom-card border-0 shadow-sm balance-card">
                  <div className="card-body text-center p-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '15px' }}>
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <div className="rounded-circle bg-white p-3 floating-icon">
                        <img src="assets/images/logo/binance.svg" alt="BNB" width="40" height="40" />
                      </div>
                    </div>
                    <h3 className="text-white fw-bold mb-1">
                      {balanceLoading ? (
                        <div className="spinner-border spinner-border-sm text-white" role="status"></div>
                      ) : (
                        `${parseFloat(bnbBalance).toFixed(4)} BNB`
                      )}
                    </h3>
                    <p className="text-white-50 mb-0">Binance Coin</p>
                    <small className="text-white-75">Via Web3 BSC</small>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div className="card custom-card border-0 shadow-sm balance-card">
                  <div className="card-body text-center p-4" style={{ background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', borderRadius: '15px' }}>
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <div className="rounded-circle bg-white p-3 floating-icon">
                        <img src="assets/images/logo/usdtLogo.png" alt="USDT" width="40" height="40" />
                      </div>
                    </div>
                    <h3 className="text-white fw-bold mb-1">
                      {balanceLoading ? (
                        <div className="spinner-border spinner-border-sm text-white" role="status"></div>
                      ) : (
                        `${parseFloat(usdtBalance).toFixed(2)} USDT`
                      )}
                    </h3>
                    <p className="text-white-50 mb-0">Tether USD</p>
                    <small className="text-white-75">BEP20 Token</small>
                  </div>
                </div>
              </div>



              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div className="card custom-card border-0 shadow-sm balance-card">
                  <div className="card-body text-center p-4" style={{ background: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)', borderRadius: '15px' }}>
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <div className="rounded-circle bg-white p-3 floating-icon pulse-animation">
                        <i className="fas fa-chart-line text-warning fa-2x"></i>
                      </div>
                    </div>
                    <h3 className="text-white fw-bold mb-1">
                      ${(parseFloat(bnbBalance) * 600 + parseFloat(usdtBalance) + parseFloat(busdBalance) + parseFloat(usdcBalance)).toFixed(2)}
                    </h3>
                    <p className="text-white-50 mb-0">Total USD Value</p>
                    <small className="text-white-75">Estimated</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Token Balances Row */}
            <div className="row mb-4">


              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <div className="card custom-card border-0 shadow-sm">
                  <div className="card-body text-center p-3" style={{ background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', borderRadius: '15px' }}>
                    <div className="d-flex align-items-center justify-content-center mb-2">
                      <div className="rounded-circle bg-white p-2">
                        <i className="fas fa-globe text-primary fa-lg"></i>
                      </div>
                    </div>
                    <h5 className="text-dark fw-bold mb-1">BSC Network</h5>
                    <p className="text-muted mb-0 small">
                      {web3 ? (
                        <span className="badge bg-success">Connected</span>
                      ) : (
                        <span className="badge bg-warning">Connecting...</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="card custom-card border-0 shadow-sm">
                  <div className="card-body text-center p-3" style={{ background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', borderRadius: '15px' }}>
                    <div className="d-flex align-items-center justify-content-center mb-2">
                      <div className="rounded-circle bg-white p-2">
                        <i className="fas fa-sync-alt text-info fa-lg"></i>
                      </div>
                    </div>
                    <h5 className="text-dark fw-bold mb-1">Web3 Direct</h5>
                    <p className="text-muted mb-0 small">Real-time blockchain data</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Debug Information Row - Remove this in production */}
            {error && (
              <div className="row mb-4">
                <div className="col-12">
                  <div className="alert alert-danger" role="alert">
                    <h6><i className="fas fa-exclamation-triangle me-2"></i>Debug Information:</h6>
                    <p className="mb-2"><strong>Error:</strong> {error}</p>
                    <p className="mb-2"><strong>Wallet Address:</strong> {walletAddress || 'Not set'}</p>
                    <p className="mb-2"><strong>Web3 Status:</strong> {web3 ? 'Connected' : 'Not connected'}</p>
                    <p className="mb-0"><strong>RPC Endpoint:</strong> {BSC_RPC_URLS[rpcIndex]}</p>
                  </div>
                </div>
              </div>
            )}


            {/* Wallet Info Row */}
            <div className="row">

              <div className="col-xl-8 col-lg-7">
                <div className="card custom-card border-0 shadow-sm wallet-info-card">
                  <div className="card-header bg-gradient-primary text-white border-0">
                    <h5 className="card-title mb-0 text-white">
                      <i className="fas fa-qrcode me-2"></i>Wallet Information
                    </h5>
                  </div>
                  <div className="card-body p-4">
                    <div className="row align-items-center">
                      <div className="col-md-4 text-center mb-3 mb-md-0">
                        <div className="qr-container">
                          <QRCodeSVG
                            value={walletAddress || 'Loading...'}
                            size={180}
                            bgColor="#ffffff"
                            fgColor="#000000"
                            level="L"
                            includeMargin={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="wallet-info">
                          <h6 className="text-muted mb-2">
                            <i className="fab fa-binance-usd me-2"></i>Binance Smart Chain (BEP20)
                          </h6>
                          <div className="address-display">
                            <label className="form-label fw-bold text-dark mb-2">Wallet Address:</label>
                            <div className="d-flex align-items-center">
                              <code className="flex-grow-1 text-break pe-2" style={{ fontSize: '0.9rem' }}>
                                {walletAddress || 'Loading wallet address...'}
                              </code>
                              <button
                                onClick={copyToClipboard}
                                className="btn btn-outline-primary btn-sm ms-2 copy-btn"
                                title="Copy to clipboard"
                                disabled={!walletAddress}
                              >
                                <i className="fas fa-copy"></i>
                              </button>
                            </div>
                          </div>
                          <div className="mt-3">
                            <small className="text-muted">
                              <i className="fas fa-info-circle me-1"></i>
                              This is your master wallet address for BEP20 tokens. Always verify the address before sending funds.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Assets Table */}
                <div className="card custom-card border-0 shadow-sm mt-4 asset-table">
                  <div className="card-header bg-gradient-success text-white border-0">
                    <h5 className="card-title mb-0 text-white">
                      <i className="fas fa-coins me-2"></i>Asset Portfolio
                    </h5>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0 asset-table">
                        <thead className="table-light">
                          <tr>
                            <th className="border-0 fw-bold">Asset</th>
                            <th className="border-0 fw-bold">Balance</th>
                            <th className="border-0 fw-bold">Name</th>
                            <th className="border-0 fw-bold">Symbol</th>
                            <th className="border-0 fw-bold">Network</th>
                            <th className="border-0 fw-bold">Contract</th>
                          </tr>
                        </thead>
                        <tbody>
                          {network && network.length > 0 ? (
                            network.map(networks => (
                              <React.Fragment key={networks.id}>
                                {networks.id &&
                                  <TokenBalance networks={networks} walletAddress={walletAddress} />
                                }
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4">
                                <div className="text-muted">
                                  <i className="fas fa-info-circle me-2"></i>
                                  No assets found or still loading...
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-5">
                <div className="card custom-card border-0 shadow-sm stats-card">
                  <div className="card-header bg-gradient-info text-white border-0">
                    <h5 className="card-title mb-0 text-white">
                      <i className="fas fa-chart-pie me-2"></i>Quick Stats
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="stats-item d-flex justify-content-between align-items-center py-3 border-bottom">
                      <div>
                        <i className="fas fa-wallet text-primary me-2"></i>
                        <span className="fw-medium">Active Tokens</span>
                      </div>
                      <span className="badge bg-primary">{network.length || 0}</span>
                    </div>
                    <div className="stats-item d-flex justify-content-between align-items-center py-3 border-bottom">
                      <div>
                        <i className="fas fa-network-wired text-warning me-2"></i>
                        <span className="fw-medium">Network</span>
                      </div>
                      <span className="badge bg-warning text-dark">BSC Mainnet</span>
                    </div>
                    <div className="stats-item d-flex justify-content-between align-items-center py-3 border-bottom">
                      <div>
                        <i className="fas fa-link text-info me-2"></i>
                        <span className="fw-medium">Web3 Status</span>
                      </div>
                      {web3 ? (
                        <span className="badge bg-success">Connected</span>
                      ) : (
                        <span className="badge bg-warning">Connecting...</span>
                      )}
                    </div>
                    <div className="stats-item d-flex justify-content-between align-items-center py-3">
                      <div>
                        <i className="fas fa-shield-alt text-success me-2"></i>
                        <span className="fw-medium">Data Source</span>
                      </div>
                      <span className="badge bg-success">Blockchain Direct</span>
                    </div>
                  </div>
                </div>

                <div className="card custom-card border-0 shadow-sm mt-4 security-card">
                  <div className="card-header bg-gradient-warning text-dark border-0">
                    <h5 className="card-title mb-0">
                      <i className="fas fa-exclamation-triangle me-2"></i>Security Notice
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="alert alert-warning border-0" role="alert">
                      <i className="fas fa-lock me-2"></i>
                      <strong>Web3 Security Notice!</strong>
                      <ul className="mb-0 mt-2">
                        <li>✅ Direct blockchain connection via Web3</li>
                        <li>✅ Real-time balance updates from BSC</li>
                        <li>⚠️ Always verify addresses before sending</li>
                        <li>🔒 Never share your private keys</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Connected to: <code>{BSC_RPC_URLS[rpcIndex]}</code>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* /row */}

          </div>
        </div>


        {/* Update Wallet Modal */}
        {showUpdateModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header bg-gradient-success text-white">
                  <h5 className="modal-title">
                    <i className="fas fa-wallet me-2"></i>Update Master Wallet
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={handleCloseModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-warning" role="alert">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    <strong>Security Warning:</strong> Your private key will be encrypted and stored securely. Never share this information with anyone.
                  </div>

                  <form onSubmit={(e) => { e.preventDefault(); updateWalletAddress(); }}>
                    <div className="mb-3">
                      <label htmlFor="walletAddress" className="form-label fw-bold">
                        <i className="fas fa-address-card me-2 text-primary"></i>Wallet Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="walletAddress"
                        placeholder="0x..."
                        value={newWalletAddress}
                        onChange={(e) => setNewWalletAddress(e.target.value)}
                        disabled={updateLoading}
                      />
                      <div className="form-text">Enter your BEP20 wallet address (42 characters starting with 0x)</div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="privateKey" className="form-label fw-bold">
                        <i className="fas fa-key me-2 text-danger"></i>Private Key
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="privateKey"
                        placeholder="Enter your wallet private key"
                        value={walletPrivateKey}
                        onChange={(e) => setWalletPrivateKey(e.target.value)}
                        disabled={updateLoading}
                      />
                      <div className="form-text text-danger">
                        <i className="fas fa-lock me-1"></i>
                        Keep this private! Never share your private key with anyone.
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <small className="text-muted">
                          <i className="fas fa-info-circle me-1"></i>
                          Network: <span className="badge bg-warning text-dark">BSC (BEP20)</span>
                        </small>
                      </div>
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={handleCloseModal}
                          disabled={updateLoading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={updateLoading}
                        >
                          {updateLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Updating...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-save me-2"></i>
                              Update Wallet
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default MasterWallet